const STORAGE_KEY = "yellowhub.lead-attribution.v1";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;
type UtmKey = typeof UTM_KEYS[number];
type Attribution = { entryPage: string; tags: Partial<Record<UtmKey, string>> };
let memory: Attribution | undefined;

const clean = (value: string) => Array.from(value)
  .filter((character) => character.charCodeAt(0) >= 32 && character.charCodeAt(0) !== 127)
  .join("").trim().slice(0, 120);

const safePage = (value: string) => {
  try {
    const url = new URL(value);
    if (url.protocol !== "http:" && url.protocol !== "https:") return "";
    // Do not forward arbitrary query strings, tokens or fragments to Telegram.
    return `${url.origin}${url.pathname}`.slice(0, 400);
  } catch {
    return "";
  }
};

const readStored = (): Attribution | undefined => {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || "null");
    if (!stored || typeof stored.entryPage !== "string" || !stored.tags || typeof stored.tags !== "object") return undefined;
    const tags: Attribution["tags"] = {};
    UTM_KEYS.forEach((key) => {
      if (typeof stored.tags[key] === "string" && clean(stored.tags[key])) tags[key] = clean(stored.tags[key]);
    });
    return { entryPage: safePage(stored.entryPage), tags };
  } catch {
    return undefined;
  }
};

export const captureLeadAttribution = () => {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  const tags: Attribution["tags"] = {};
  UTM_KEYS.forEach((key) => {
    const value = clean(url.searchParams.get(key) || "");
    if (value) tags[key] = value;
  });
  // A new tagged visit replaces the campaign as a whole; untagged navigation preserves it.
  const previous = memory || readStored();
  memory = Object.keys(tags).length
    ? { entryPage: safePage(url.href), tags }
    : previous || { entryPage: safePage(url.href), tags: {} };
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(memory));
  } catch {
    // Blocked storage must never prevent a visitor from submitting a form.
  }
};

export const getLeadAttributionFields = (): Record<string, string> => {
  captureLeadAttribution();
  if (!memory || typeof window === "undefined") return {};
  const labels: Record<UtmKey, string> = {
    utm_source: "Джерело (UTM)",
    utm_medium: "Канал (UTM)",
    utm_campaign: "Кампанія (UTM)",
    utm_content: "Оголошення (UTM)",
    utm_term: "Ключове слово (UTM)",
  };
  const fields: Record<string, string> = {
    "Джерело (UTM)": memory.tags.utm_source || "Не визначено",
    "Сторінка входу": memory.entryPage,
    Сторінка: safePage(window.location.href),
  };
  UTM_KEYS.forEach((key) => {
    const value = memory?.tags[key];
    if (value) fields[labels[key]] = value;
  });
  return fields;
};
